import React from 'react'
import { Button } from '@mui/material'

const GradientButton = ({
  children,
  onClick,
  disabled = false,
  type = 'button',
  variant = 'contained',
  startIcon = null,
  endIcon = null,
  size = 'medium',
  fullWidth = false,
  sx = {},
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      type={type}
      variant={variant}
      startIcon={startIcon}
      endIcon={endIcon}
      size={size}
      fullWidth={fullWidth}
      sx={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        px: 3,
        py: 1.5,
        fontWeight: 500,
        borderRadius: '8px',
        textTransform: 'none',
        boxShadow: '0 4px 6px rgba(102, 126, 234, 0.25)',
        '&:hover': {
          background: 'linear-gradient(135deg, #5a67d8 0%, #6b4c9a 100%)',
          transform: 'translateY(-2px)',
          boxShadow: '0 8px 12px rgba(102, 126, 234, 0.35)',
        },
        '&:active': {
          transform: 'translateY(0)',
          boxShadow: '0 2px 4px rgba(102, 126, 234, 0.25)',
        },
        '&:disabled': {
          background: 'linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 100%)',
          color: '#666',
          transform: 'none',
          boxShadow: 'none',
        },
        transition: 'all 0.2s ease',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  )
}

export default GradientButton
